import React from "react";
import { InfoOutlined, VerifiedUser } from "@material-ui/icons";
import { Button, IconButton, Tooltip } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/route";
import { DEFAULT_PROCESSING_TIMELINE_INFO } from "../../constants/fundTimelines";

function OverlayAlertBox(props) {
  const history = useHistory();
  const processingTimeline = props.processingTimeline?.trim() || "Not available";
  const processingTimelineInfo =
    props.processingTimelineInfo?.trim() || DEFAULT_PROCESSING_TIMELINE_INFO;
  const okay = () => {
    history.push(ROUTES.MY_INVESTMENTS);
  };

  return (
    <div className="overlay-alert">
      <div className="alert-box">
        <div className="icon-bgRampver">
          <VerifiedUser fontSize="large" />
        </div>
        <h2>Thank you for investing on Rampver Online!</h2>
        <span>
          We will validate your payment and process your investment according
          to the fund&apos;s processing timeline below. We will email you the
          complete investment details once confirmed and allocated.
        </span>
        <br /> <br />
        <span>
          <strong>Fund processing timeline:</strong>
          <Tooltip title={processingTimelineInfo} arrow PopperProps={{ disablePortal: true }}>
            <IconButton size="small" aria-label="About fund processing timeline">
              <InfoOutlined fontSize="small" />
            </IconButton>
          </Tooltip>{" "}
          {processingTimeline}
        </span>
        <br /> <br />
        <Button
          variant="contained"
          color="primary"
          className="custom-btn"
          size="large"
          onClick={okay}
          fullWidth
        >
          Okay
        </Button>
      </div>
    </div>
  );
}

export default OverlayAlertBox;
